// extracted by mini-css-extract-plugin
export var container = "DeliveryNoteSelect-module--container--xpXaS";
export var noDeliveries = "DeliveryNoteSelect-module--noDeliveries--GvvjD";
export var subHeader = "DeliveryNoteSelect-module--subHeader--BoQjC";